// extracted by mini-css-extract-plugin
export default {"answerLink":"Answer_answerLink__Qjz9X","answerTitle":"Answer_answerTitle__PJAb4","read":"Answer_read__4nCKY","loader":"Answer_loader__COEZ+"};